import { SyncOutlined } from "@ant-design/icons";
import { TaskRecurrenceFragment } from "gql/graphql";
import Tag from "@/shared/data-display/tag";
import { Hidable, Value } from "@/shared/value";
import { useFrequencyLabel } from "./model/use-frequency-label";

/**
 * Бейдж частоты повтора («Каждый месяц»). У однократной задачи ничего не рисует,
 * поэтому его можно ставить рядом со сроком не глядя на тип задачи.
 */
export function TaskRecurrence({
  data,
}: {
  data?: Hidable<TaskRecurrenceFragment>;
}) {
  const label = useFrequencyLabel();

  return (
    <Value data={data}>
      {(task) => {
        if (task.completion.__typename !== "RecurringCompletionDto") {
          return null;
        }

        return (
          <Tag icon={<SyncOutlined />} className="!me-0">
            {label(task.completion.frequency)}
          </Tag>
        );
      }}
    </Value>
  );
}
